import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../fonts/TIMES.TTF-16-Regular.woff';
import '../fonts/TIMESBD.TTF-16-Bold.woff';

const Main = function () {
  const portrait = 'https://images.getpie.app/users/e541d6b0-29c8-11ef-8aa7-f509ad0c08d1/profile-146683b9-46a7-4131-863f-31dda8abf5af.jpg';

  const handleEmailClick = () => {
    const email = ['hunter', 'hunterhusar.net'].join('@');
    window.location.href = `mailto:${email}`;
  };

  React.useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise().catch(err => console.log(err));
    }
  }, []);

  return (
    <div className="flex flex-column flex-row-l">
      {/* Left - Schrödinger Equation & Particle in Box Solution */}
      <div className="w-100 w-50-l f5 times-bold" style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', overflowY: 'auto', background: '#f5f5f0', color: '#000'}}>
        <div style={{textAlign: 'center', color: '#000', fontSize: '1.2rem', maxWidth: '95%'}}>
          {/* Main Equation */}
          <div style={{paddingBottom: '2rem', borderBottom: '1px solid #999', marginBottom: '2rem'}}>
            <div style={{fontSize: '0.9rem', color: '#555', marginBottom: '0.5rem'}}>Time-Independent Schrödinger</div>
            <div>{"$$-\\frac{\\hbar^2}{2m}\\frac{d^2\\Psi}{dx^2} + V(x)\\Psi = E\\Psi$$"}</div>
          </div>

          {/* Particle in a Box */}
          <div>
            <div style={{fontSize: '1rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#000'}}>Particle in a Box (0 ≤ x ≤ L)</div>

            <div style={{paddingBottom: '1.2rem', marginBottom: '1.2rem', borderBottom: '1px solid #ccc'}}>
              <div style={{fontSize: '0.85rem', color: '#666', marginBottom: '0.3rem', textAlign: 'left'}}>Step 1: Inside box, V(x) = 0</div>
              <div>{"$$\\frac{d^2\\Psi}{dx^2} + k^2\\Psi = 0, \\quad k^2 = \\frac{2mE}{\\hbar^2}$$"}</div>
            </div>

            <div style={{paddingBottom: '1.2rem', marginBottom: '1.2rem', borderBottom: '1px solid #ccc'}}>
              <div style={{fontSize: '0.85rem', color: '#666', marginBottom: '0.3rem', textAlign: 'left'}}>Step 2: General solution</div>
              <div>{"$$\\Psi(x) = A\\sin(kx) + B\\cos(kx)$$"}</div>
            </div>

            <div style={{paddingBottom: '1.2rem', marginBottom: '1.2rem', borderBottom: '1px solid #ccc'}}>
              <div style={{fontSize: '0.85rem', color: '#666', marginBottom: '0.3rem', textAlign: 'left'}}>Step 3: Boundary conditions, Ψ(0) = Ψ(L) = 0</div>
              <div>{"$$\\Psi_n(x) = A\\sin\\left(\\frac{n\\pi x}{L}\\right), \\quad n = 1, 2, 3, ...$$"}</div>
            </div>

            <div>
              <div style={{fontSize: '0.85rem', color: '#666', marginBottom: '0.3rem', textAlign: 'left'}}>Step 4: Normalization & Energy</div>
              <div style={{paddingBottom: '0.5rem'}}>{"$$\\Psi_n(x) = \\sqrt{\\frac{2}{L}}\\sin\\left(\\frac{n\\pi x}{L}\\right)$$"}</div>
              <div>{"$$E_n = \\frac{n^2\\pi^2\\hbar^2}{2mL^2}$$"}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Split on desktop, stacked on mobile */}
      <div className="w-100 w-50-l flex flex-column" style={{background: '#f5f5f0', color: '#000'}}>
        {/* Top Right - Bio */}
        <div className="w-100" style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', background: 'transparent', color: '#f5f5f0'}}>
          <div className="marquee-container" style={{marginBottom: 0, background: '#f5f5f0', borderBottom: '2px solid #000'}}>
            <div className="marquee-content" style={{color: '#000'}}>
              welcome to my website!
            </div>
          </div>
          <div className="f3 bio-text" style={{fontFamily: 'TimesBold, cursive', lineHeight: '1.6', padding: '1rem 1rem 1.2rem 1rem', borderBottom: '2px solid #fff', background: '#1a1a1a'}}>
            <img src={portrait} alt="Portrait" className="br-100 ba bio-portrait" style={{width: '120px', height: '120px', float: 'left', marginRight: '1rem', marginBottom: 0}}/>
            <a href="https://www.linkedin.com/in/hunter-husar/" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline'}}>computer person</a>, <a href="https://en.wikipedia.org/wiki/Mahjongg_(band)" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline'}}>synthesist</a>, <a href="https://unitedstatesofcare.org/bio/hunter-husar/" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline'}}>friend to all</a>, <a href="https://www.simoneandhunter.com/" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline'}}>husband</a>, father.
            <br/>
            vp of engineering @ <a href="https://www.getpie.app" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline'}}>pie</a>
            <br/>
            <button onClick={handleEmailClick} style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, textDecoration: 'underline', fontFamily: 'TimesBold, cursive'}}>
              contact me
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ReactDOM.render(
  <Main/>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/